<template>
  <footer class="footer">
    <div class="footer-section">
      <div class="wrapper">
        <div class="left">
          <ul class="nav">
            <li class="nav__item" @click="scrollToSection('features')">
              <div class="desc">Our Features</div>
            </li>
            <li class="nav__item" @click="scrollToSection('categories')">
              <div class="desc">Categories</div>
            </li>
            <li class="nav__item" @click="scrollToSection('how-it-works')">
              <div class="desc">How It Works</div>
            </li>
            <li class="nav__item" @click="scrollToSection('contact')">
              <div class="desc">Contact Us</div>
            </li>
          </ul>
          <ul class="nav" v-if="$parent.textPageList.length">
            <template v-for="item in $parent.textPageList">
              <li class="nav__item nav__item-text-pages" :key="item.id">
                <div @click="$parent.goToPage(item.url)" class="desc">
                  {{ item.title }}
                </div>
              </li>
            </template>
          </ul>
        </div>
        <div class="center">
          <router-link to="/" class="logo">
            <img src="./../assets/logo-mini.svg" class="img" />
          </router-link>
        </div>
        <div class="right">
          <div class="text">
            <div class="desc link" v-html="$parent.settings.company_name"></div>
            <div class="desc link">
              <img src="./../assets/location.svg" class="img" />
              <span
                v-if="$parent.settings.requisites"
                v-html="$parent.settings.requisites.replace(/\n/g, '<br>')"
              ></span>
            </div>
            <div class="desc link">
              <img src="./../assets/envelope.svg" class="img" />
              <a
                v-if="$parent.settings.support_email"
                :href="'mailto:' + $parent.settings.support_email"
                >{{ $parent.settings.support_email }}</a
              >
            </div>
            <div class="desc link">
              <img src="./../assets/phone.svg" class="img" />
              <a
                v-if="$parent.settings.support_phone"
                :href="
                  'tel:' +
                  ($parent.settings.support_phone?.replace(/[\s()-]/g, '') ||
                    '')
                "
                >{{ $parent.settings.support_phone }}</a
              >
            </div>
            <div class="social-links-wrapper" v-if="$parent.socialLinks.length">
              <a
                :href="link.url"
                v-for="link in $parent.socialLinks"
                class="link"
                target="_blank"
                v-bind:key="link.url"
              >
                <img :src="link.image" class="link-img" />
              </a>
            </div>
            <ul class="list">
              <!-- <li class="item">
                <img src="./../assets/logo-rounded.svg" class="img" />
              </li> -->
              <li class="item">
                <img src="./../assets/mc_symbol.svg" class="img" />
              </li>
              <li class="item">
                <img src="./../assets/visa.svg" class="img" />
              </li>
              <li class="item">
                <img src="./../assets/3ds.svg" class="img ds" />
              </li>
              <li class="item">
                <img src="./../assets/pci.svg" class="img pci" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="copyright-section">
        <div class="wrapper">
          <div class="left"></div>
          <div class="right">
            <div class="desc">{{ $parent.settings.copyright }}</div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: [],
  data: function () {
    return {};
  },
  methods: {
    scrollToSection(section) {
      this.$emit("scrollToSection", section);
    },
    setStableDiffusionModel() {
      let model = this.$parent.models.find((obj) => obj.id === 1);
      this.$emit("setActiveModel", model);
    },
  },
  mounted() {},
};
</script>
